import { all } from 'redux-saga/effects';

import removeTag from './removeTag';
import updateTag from './updateTag';

export function* saga() {
    yield all([updateTag(), removeTag()]);
}
